// extracted by mini-css-extract-plugin
export default {"spinnerDual":"Spinner_spinnerDual__OnMqo","spin":"Spinner_spin__Dpx4E","loader":"Spinner_loader__RBfgG"};